import React, { Fragment } from 'react';
import ContentMatrix, { MatrixDef } from 'components/general/ContentMatrix/ContentMatrix';
import SubHeader from 'components/general/SubHeader/SubHeader';
import ArticleHeader from 'components/general/ArticleHeader/ArticleHeader';
import withLoadingError from 'components/hoc/withLoadingError';
import MatrixSetSkeleton from 'components/general/MatrixSet/MatrixSetSkeleton';
import LinkProps from 'utils/ts/LinkProps';

const MatrixSet: React.SFC<MatrixSetProps> = ({
  title,
  category,
  content = [],
}) => (
  <Fragment>
    {title && (
      <div className="block block--restrict rich-text">
        <ArticleHeader
          title={title}
          category={category}
        />
      </div>
    )}
    {content.map(matrix => (
      <Fragment key={`matrix-${matrix.title}-${title}`}>
        {matrix.title && (title !== matrix.title) && (
          <div className="block block--restrict block--sub-header block--clear">
            <SubHeader title={matrix.title} id />
          </div>
        )}
        <ContentMatrix blocks={matrix.blocks} />
      </Fragment>
    ))}
  </Fragment>
);

interface MatrixSetProps {
  title?: string;
  category?: {
    title: string;
    to?: LinkProps;
  };
  content: MatrixDef[];
}

export default withLoadingError({
  itemsProp: 'content',
  renderLoading: () => (
    <MatrixSetSkeleton />
  ),
})(MatrixSet);

